import { ErrorInfo } from 'react';
import { withScope, captureException } from '@sentry/react';

export const shouldCaptureError = (): boolean =>
  process.env.REACT_APP_ENVIRONMENT === 'production' ||
  process.env.REACT_APP_ENVIRONMENT === 'preprod';

const captureError = (error: Error, errorInfo: ErrorInfo) => {
  if (!shouldCaptureError()) {
    console.error(error, errorInfo);
    return;
  }

  withScope((scope) => {
    Object.entries(errorInfo).forEach((entry) => {
      const [key, value] = entry;
      scope.setExtra(key, value);
    });
    captureException(error);
  });
};

export default captureError;
